exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".paypal-logo[data-v-45da7f68] {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.paypal-logo > svg[data-v-45da7f68] {\n  width: 100%;\n  max-width: 72px;\n  height: auto;\n}", ""]);

// exports
